import { createElement, type ComponentType } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { AppPaths } from '@/config/app-paths'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { PayrollPermissions } from '@/features/payroll/permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Boss route page export "${exportName}" not found`)
  }
  return {
    Component: createPermissionGuardedPage(PayrollPermissions.adminConsoleAccess, Page, {
      mode: 'all',
      administratorBypass: true,
    }),
  }
}

export const bossRoutes: RouteObject[] = [
  {
    path: 'overview',
    element: createElement(Navigate, { to: AppPaths.inHouseAttendance, replace: true }),
  },
  {
    path: 'overview/payrolls',
    element: createElement(Navigate, { to: AppPaths.inHouseAttendance, replace: true }),
  },
  {
    path: 'overview/in-house-attendance',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/in-house-attendance-page'),
        'InHouseAttendancePage',
      ),
  },
  {
    path: 'overview/attendance',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/boss-attendance-page'), 'BossAttendancePage'),
  },
]
